import Vue from "vue";
import VueRouter from "vue-router";
import Auth from "@/utilities/auth";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import("@/views/HomeView.vue"),
            meta: {
                requiresAuth: true,
                isCustomerRoute: false,
                icon: "home",
                pageTitle: "Ana Sayfa",
            },
        },
        {
            path: "/Auth/Login",
            name: "login",
            component: () => import("@/views/auth/LoginView.vue"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "/Auth/CustomerPasswordSetup",
            name: "customer-password-setup",
            component: () => import("@/views/auth/CustomerPasswordSetup.vue"),
            meta: {
                layout: "full",
                requiresAuth: false,
            },
        },
        {
            path: "/SystemManagement/User",
            name: "user",
            component: () => import("@/views/user/UserView.vue"),
            meta: {
                requiresRole: ["USER_OPERATIONS"],
                requiresAuth: true,
                icon: "people",
                pageTitle: "Sistem Yönetimi",
                breadcrumb: [
                    {
                        text: "Kullanıcılar",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Payment/Errors",
            name: "payment-errors",
            component: () => import("@/views/payment-error/PaymentErrorView.vue"),
            meta: {
                requiresRole: ["PAYMENT_ERRORS_MANAGEMENT"],
                requiresAuth: true,
                icon: "warning_amber",
                pageTitle: "Ödeme Yönetimi",
                breadcrumb: [
                    {
                        text: "Hatalı Ödeme İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemManagement/Role",
            name: "role",
            component: () => import("@/views/role/RoleView.vue"),
            meta: {
                requiresRole: ["ROLE_OPERATIONS"],
                requiresAuth: true,
                icon: "settings_accessibility",
                pageTitle: "Rol Yönetimi",
                breadcrumb: [
                    {
                        text: "Rol Yönetimi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemManagement/BankIntegration",
            name: "bank-integration",
            component: () => import("@/views/bank-integration/BankIntegrationView.vue"),
            meta: {
                requiresRole: ["BANK_OPERATIONS"],
                requiresAuth: true,
                icon: "account_balance",
                pageTitle: "Banka Entegrasyonu",
                breadcrumb: [
                    {
                        text: "Banka Entegrasyonu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemManagement/MailIntegration",
            name: "mail-integration",
            component: () => import("@/views/mail-integration/MailIntegrationView.vue"),
            meta: {
                requiresRole: ["E_MAIL_OPERATIONS"],
                requiresAuth: true,
                icon: "mail_lock",
                pageTitle: "E-Posta Entegrasyonu",
                breadcrumb: [
                    {
                        text: "E-Posta Entegrasyonu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Notify",
            name: "notify",
            component: () => import("@/views/notifications/NotificationView.vue"),
            meta: {
                //requiresRole:["NOTIFICATIONS_VIEW"],
                requiresAuth: true,
                icon: "upcoming",
                pageTitle: "Mail Gönderim Durumu",
                breadcrumb: [
                    {
                        text: "Mail Gönderim Durumu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/NotifySms",
            name: "notify-sms",
            component: () => import("@/views/notifications/SmsNotificationView.vue"),
            meta: {
                //requiresRole:["NOTIFICATIONS_VIEW"],
                requiresAuth: true,
                icon: "upcoming",
                pageTitle: "SMS Gönderim Durumu",
                breadcrumb: [
                    {
                        text: "SMS Gönderim Durumu",
                        active: true,
                    },
                ],
            },
        },

        {
            path: "/SystemManagement/UserExcuseType",
            name: "user-excuse-type",
            component: () => import("@/views/user-excuse-type/UserExcuseTypeView.vue"),
            meta: {
                requiresRole: ["EXCUSE_TYPE_OPERATIONS"],
                requiresAuth: true,
                icon: "mail_lock",
                pageTitle: "İzin Türü İşlemleri",
                breadcrumb: [
                    {
                        text: "İzin Türü İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/UserExcuse",
            name: "user-excuse",
            component: () => import("@/views/user-excuse/UserExcuseView.vue"),
            meta: {
                requiresRole: ["EXCUSE_OPERATIONS"],
                requiresAuth: true,
                icon: "king_bed",
                pageTitle: "İzin İşlemleri",
                breadcrumb: [
                    {
                        text: "İzin İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/ResponsibleUserApproveReports",
            name: "responsible-user-approve-report",
            component: () => import("@/views/responsible-user-approvement-report/ResponsibleUserApprovementReportView.vue"),
            meta: {
                requiresRole: ["RESPONSIBLE_USER_APPROVE_REPORTS"],
                requiresAuth: true,
                icon: "flag_circle",
                pageTitle: "Sorumlu Personel Taksit Onay Raporu",
                breadcrumb: [
                    {
                        text: "Sorumlu Personel Taksit Onay Raporu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/WithoutInvoiceReports",
            name: "without-invoice-report",
            component: () => import("@/views/without-invoice-report/WithoutInvoiceReportView.vue"),
            meta: {
                requiresRole: ["WITHOUT_INVOICE_REPORTS"],
                requiresAuth: true,
                icon: "pin_invoke",
                pageTitle: "Faturasız Ödeme Linki Gönderim Raporu",
                breadcrumb: [
                    {
                        text: "Faturasız Ödeme Linki Gönderim Raporu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/ReportAutoSentInvoiceNotify",
            name: "auto-payment-link-report",
            component: () => import("@/views/report-auto-sent-invoice-notify/ReportAutoSentInvoiceNotify.vue"),
            meta: {
                requiresAuth: true,
                icon: "pin_invoke",
                pageTitle: "Otomatik Gönderim Linkleri Raporu",
                breadcrumb: [
                    {
                        text: "Otomatik Gönderim Linkleri Raporu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VadeTarihiXGunGecmisFaturalar",
            name: "vade-tarihi-x-gun-gecmis-faturalar",
            component: () => import("@/views/vade-tarihi-x-gun-gecmis-faturalar/VadeTarihiXGunGecmisFaturalarView.vue"),
            meta: {
                requiresRole: ["VADE_TARIHI_X_DAYS_PASSED_REPORT"],
                requiresAuth: true,
                icon: "flag_circle",
                pageTitle: "Vade Tarihi X Gün Geçmiş Faturalar",
                breadcrumb: [
                    {
                        text: "Vade Tarihi X Gün Geçmiş Faturalar",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/InstallmentLastDayInvoices",
            name: "installment-last-day-invoices",
            component: () => import("@/views/InstallmentLastDayInvoices/InstallmentLastDayInvoices.vue"),
            meta: {
                // requiresRole:["LAST_PAYMENT_WITH_INSTALLMENT_AND_10_DAYS_PASSED_INVOICE"],
                requiresAuth: true,
                icon: "restore",
                pageTitle: "Son Taksit Günü Bugün Olan Ödemeler",
                breadcrumb: [
                    {
                        text: "Son Taksit Günü Bugün Olan Ödemeler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemManagement/SMSIntegration",
            name: "sms-integration",
            component: () => import("@/views/sms-integration/SMSIntegrationView.vue"),
            meta: {
                requiresRole: ["SMS_OPERATIONS"],
                requiresAuth: true,
                icon: "textsms",
                pageTitle: "SMS Entegrasyonu",
                breadcrumb: [
                    {
                        text: "SMS Entegrasyonu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemManagement/UserReportAssign",
            name: "user-report-assign",
            component: () => import("@/views/report-user/ReportUserView.vue"),
            meta: {
                requiresRole: ["REPORT_ASSIGN"],
                requiresAuth: true,
                icon: "contact_page",
                pageTitle: "Kullanıcı Rapor Ataması",
                breadcrumb: [
                    {
                        text: "Kullanıcı Rapor Ataması",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CustomerAccount",
            name: "customer-account",
            component: () => import("@/views/customer-account/CustomerAccountView.vue"),
            meta: {
                requiresRole: ["CUSTOMER_ACCOUNTS_OPERATIONS"],
                requiresAuth: true,
                icon: "groups",
                pageTitle: "Cariler",
                breadcrumb: [
                    {
                        text: "Cariler",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path:'/HesapHareketleri',
        //   name:'customer-account-for-customer',
        //   component: () => import('@/views/customer-account/CustomerAccountForCustomerView.vue'),
        //   meta: {
        //     requiresRole:["CUSTOMER_ACCOUNTS_OPERATIONS", "Customer"],
        //     requiresAuth: true,
        //     icon: 'groups',
        //     pageTitle: 'Cariler',
        //     breadcrumb: [
        //       {
        //         text: 'Cariler',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        {
            path: "/CampaignProduct/Sun",
            name: "campaign-product-sun",
            component: () => import("@/views/campaign-product/sun/SunView.vue"),
            meta: {
                requiresRole: ["SUN_CAMPAING_PRODUCT_OPERATIONS"],
                requiresAuth: true,
                icon: "production_quantity_limits",
                pageTitle: "Güneş",
                breadcrumb: [
                    {
                        text: "Kampanya Ürünleri",
                        active: false,
                    },
                    {
                        text: "Güneş",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CustomerAccountDetail/:code",
            name: "customer-account-detail",
            component: () => import("@/views/customer-account/CustomerAccountDetailView.vue"),
            meta: {
                requiresRole: ["CUSTOMER_ACCOUNT_DETAIL_OPERATIONS"],
                requiresAuth: true,
                icon: "groups",
                pageTitle: "Cari Hareketleri",
                breadcrumb: [
                    {
                        text: "Cari Hareketleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/customer-portal",
            name: "customer-portal",
            component: () => import("@/views/customer-account/CustomerPortalView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["Customer"],
                icon: "account_balance_wallet",
                pageTitle: "Hesap Ekstrem",
                breadcrumb: [
                    {
                        text: "Hesap Ekstrem",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path:'/HesapHareketleriDetay/:code',
        //   name:'customer-account-detail-for-customer',
        //   component: () => import('@/views/customer-account/CustomerAccountDetailForCustomerView.vue'),
        //   meta: {
        //     requiresRole:["Customer"],
        //     requiresAuth: true,
        //     icon: 'groups',
        //     pageTitle: 'Cari Hareketleri',
        //     breadcrumb: [
        //       {
        //         text: 'Cari Hareketleri',
        //         active: true,
        //      }
        //     ],

        //   },
        // },
        {
            path: "/SystemParameter",
            name: "system-parameter",
            component: () => import("@/views/system-parameter/SystemParameterView.vue"),
            meta: {
                requiresRole: ["SYSTEM_PARAMETER_OPERATIONS"],
                requiresAuth: true,
                icon: "dns",
                pageTitle: "Sistem Parametreleri",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/BankInstallment",
            name: "bank-installment",
            component: () => import("@/views/bank-installment/BankInstallmentView.vue"),
            meta: {
                requiresRole: ["BANK_INSTALLMENT_OPERATIONS"],
                requiresAuth: true,
                icon: "dns",
                pageTitle: "Banka Taksit İşlemleri",
                breadcrumb: [
                    {
                        text: "Banka Taksit İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/BankInstallmentCampaign",
            name: "bank-installment-campaign",
            component: () => import("@/views/bank-installment-campaign/BankInstallmentCampaignView.vue"),
            meta: {
                requiresRole: ["BANK_INSTALLMENT_CAMPAIGN_OPERATIONS"],
                requiresAuth: true,
                icon: "campaign",
                pageTitle: "Banka Taksit Kampanya İşlemleri",
                breadcrumb: [
                    {
                        text: "Banka Taksit Kampanya İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Quick/Payment",
            name: "quick-payment",
            component: () => import("@/views/quick/payment/QuickPaymentView.vue"),
            meta: {
                requiresRole: ["BANK_INSTALLMENT_OPERATIONS"], //todo
                requiresAuth: true,
                icon: "campaign",
                pageTitle: "Ödemeler",
                breadcrumb: [
                    {
                        text: "Ödemeler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Quick/PaymentInstallment",
            name: "quick-payment-installment",
            component: () => import("@/views/quick/payment-installment/QuickPaymentInstallmentView.vue"),
            meta: {
                requiresRole: ["QUICK_PAYMENT_INSTALLMENT_LIST"],
                requiresAuth: true,
                icon: "campaign",
                pageTitle: "Taksit Yapılabilir Ödemeler",
                breadcrumb: [
                    {
                        text: "Taksit Yapılabilir Ödemeler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Payment/:code",
            name: "payment",
            component: () => import("@/views/payment/PaymentView.vue"),
            meta: {
                layout: "full",
                contentClass: "p-1",
            },
        },
        {
            path: "/InvoiceDetail/:customerCode/:documentNumber",
            name: "invoice-detail-from-netsis",
            component: () => import("@/views/invoice-detail-from-netsis/InvoiceDetailFromNetsisView.vue"),
            meta: {
                layout: "full",
                contentClass: "p-1",
            },
        },
        {
            path: "/Payments",
            name: "payments",
            component: () => import("@/views/payments/PaymentsView.vue"),
            meta: {
                requiresRole: ["PAYMENT_LIST"],
                requiresAuth: true,
                icon: "payments",
                pageTitle: "Ödemeler",
                breadcrumb: [
                    {
                        text: "Ödemeler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/LastWeekActions",
            name: "last-week-actions",
            component: () => import("@/views/last-week-actions/LastWeekActionsView.vue"),
            meta: {
                requiresRole: ["LAST_WEEK_ACTIONS_VIEW"],
                requiresAuth: true,
                icon: "payments",
                pageTitle: "Haftalık İşlem Hareketleri",
                breadcrumb: [
                    {
                        text: "Haftalık İşlem Hareketleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/DailyTotalAmountStats",
            name: "daily-total-amount-stats",
            component: () => import("@/views/stats/daily-stats/DailyStatsByUserView.vue"),
            meta: {
                requiresRole: ["PLASIYER_DATE_RANGE_REPORTS_VIEW"],
                requiresAuth: true,
                icon: "query_stats",
                pageTitle: "Plasiyer Tahsilat Raporu",
                breadcrumb: [
                    {
                        text: "Plasiyer Tahsilat Raporu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Receipt/:code",
            name: "receipt",
            component: () => import("@/views/receipt/ReceiptView.vue"),
            meta: {
                layout: "full",
                contentClass: "p-1",
            },
        },
        {
            path: "/PaymentError/:groupCode/:receiptCode",
            name: "payment-error",
            component: () => import("@/views/payment/PaymentErrorView.vue"),
            meta: {
                layout: "full",
                contentClass: "d-flex align-items-center justify-content-center h-100",
            },
        },
        {
            path: "/Profile",
            name: "profile",
            component: () => import("@/views/profile/ProfileView.vue"),
            meta: {
                requiresAuth: true,
                icon: "account_circle",
                pageTitle: "Profil Yönetimi",
                breadcrumb: [
                    {
                        text: "Profil Yönetimi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Activation/:code",
            name: "activate",
            component: () => import("@/views/auth/ActivateView.vue"),
            meta: {
                layout: "full",
                contentClass: "d-flex align-items-center justify-content-center h-100",
            },
        },
        {
            path: "/:code",
            name: "paymentroute",
            component: () => import("@/views/payment/PaymentRouteView.vue"),
            meta: {
                layout: "full",
                contentClass: "p-1",
            },
        },
        {
            path: "/test",
            name: "test",
            component: () => import("@/views/Test.vue"),
            meta: {},
        },
        {
            path: "/B2B/Orders",
            name: "b2b-orders",
            component: () => import("@/views/b2b/OrdersView.vue"),
            meta: {
                requiresRole: ["WITHOUT_INVOICE_REPORTS"],
                requiresAuth: true,
                icon: "storefront",
                pageTitle: "Sipariş Yönetim Merkezi",
                breadcrumb: [
                    {
                        text: "Siparişler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Warehouse/Cell-Balances",
            name: "warehouse-cell-balance",
            component: () => import("@/views/warehouse/CellBalanceView.vue"),
            meta: {
                pageTitle: "Stok Durumu",
                breadcrumb: [{ text: "Depo Yönetimi" }, { text: "Stok Durumu", active: true }],
            },
        },
        {
            path: "/Warehouse/Cell-Definitions",
            name: "warehouse-cell-definition",
            component: () => import("@/views/warehouse/CellDefinitionView.vue"),
            meta: {
                pageTitle: "Hücre Tanımları",
                breadcrumb: [{ text: "Depo Yönetimi" }, { text: "Hücre Tanımları", active: true }],
            },
        },
        {
            path: "/Warehouse/Goods-Receipt",
            name: "warehouse-goods-receipt",
            component: () => import("@/views/warehouse/GoodsTransferView.vue"),
            meta: {
                pageTitle: "İade / Mal Kabul İşlemleri",
                breadcrumb: [{ text: "Depo Yönetimi" }, { text: "Fatura Listesi", active: true }],
            },
        },
        {
            path: "/warehouse/internal-transfer",
            name: "warehouse-internal-transfer",
            component: () => import("@/views/warehouse/InternalTransferView.vue"),
            meta: {
                pageTitle: "Hücre Transferi",
                breadcrumb: [{ text: "Depo Yönetimi" }, { text: "Hücre Transferi", active: true }],
            },
        },
        {
            path: "/warehouse/shipment-transfer",
            name: "warehouse-shipment-transfer",
            component: () => import("@/views/warehouse/ShipmentTransferView.vue"),
            meta: {
                pageTitle: "Sevkiyat İşlemleri",
                breadcrumb: [{ text: "Depo Yönetimi" }, { text: "Fatura Listesi", active: true }],
            },
        },
        {
            path: "/B2B/Orders/:id",
            name: "b2b-order-detail",
            component: () => import("@/views/b2b/components/OrderDetail.vue"),
            props: true,
            meta: {
                requiresAuth: true,
                requiresRole: ["WITHOUT_INVOICE_REPORTS"],
                pageTitle: "Sipariş Detayı",
                breadcrumb: [
                    {
                        text: "Ticimax Sipariş Listesi",
                        to: { name: "b2b-orders" },
                    },
                    {
                        text: "Sipariş Detayı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/b2b/ticimax-order-detail/:id",
            name: "b2b-ticimax-order-detail",
            component: () => import("@/views/b2b/components/TicimaxOrderDetail.vue"),
            props: true,
            meta: {
                requiresAuth: true,
                pageTitle: "Ticimax Sipariş Detayı",
                breadcrumb: [
                    { text: "Ticimax Sipariş Listesi", to: { name: "b2b-orders" } },
                    { text: "Ticimax Sipariş Detayı", active: true },
                ],
            },
        },
        {
            path: "/privacy-policy",
            name: "privacy-policy",
            component: () => import("@/views/pages/PrivacyPolicy.vue"),
            meta: {
                layout: "full",
                pageTitle: "Gizlilik Politikası",
                breadcrumb: [
                    {
                        text: "Gizlilik Politikası",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/404",
            name: "error-404",
            component: () => import("@/views/error/Error404.vue"),
            meta: { layout: "full" },
        },
        {
            path: "*",
            redirect: { name: "error-404" },
        },
    ],
});

router.beforeEach((to, from, next) => {
    const isUser = Auth.isAuthenticated;
    const isCustomer = Auth.customerAuthenticated;
    const isAuthenticated = isUser || isCustomer;

    if (isCustomer && to.meta.isCustomerRoute === false) {
        return next({ name: "customer-portal" });
    }

    const requiresAuth = to.matched.some((r) => r.meta?.requiresAuth);
    const requiredRoles = to.meta?.requiresRole;

    if ((to.name === "login" || to.path === "/login") && isAuthenticated) {
        return next(isCustomer ? { name: "customer-portal" } : { name: "home" });
    }

    if (requiresAuth && !isAuthenticated) {
        return next({ name: "login", query: { redirect: to.fullPath } });
    }

    if (requiredRoles) {
        if (isUser) {
            if (Auth.hasRole(requiredRoles)) return next();
            return next({ name: "home" });
        }
        if (isCustomer) {
            if (requiredRoles.includes("Customer") || requiredRoles.includes("Cari")) return next();
            return next({ name: "customer-portal" });
        }
    }

    return next();
});

router.afterEach(() => {
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router;
